import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { CityService } from "../../core/service/city.service";
import { NetworkService } from "../../core/service/network.service";
import { City } from "../../core/model/city";
import { Network } from "../../core/model/network";

@Component({
  selector: "app-add-city",
  templateUrl: "./add-city.component.html",
  styleUrls: ["./add-city.component.scss"],
})
export class AddCityComponent implements OnInit {
  pressButton: Boolean = false;
  form: FormGroup;

  city: City = new City();
  networks: Network[];

  constructor(
    private _router: Router,
    private _cityService: CityService,
    private _networkService: NetworkService,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
      network: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getNetworks();
  }

  getNetworks() {
    this._networkService.getAllNetworks().subscribe(
      (data) => {
        this.networks = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this._cityService
      .postCity(this.city)
      .pipe(first())
      .subscribe(
        (data) => {
          this.goToList();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  cancel(): void {
    this.goToList();
  }

  private goToList(): void {
    this._router.navigateByUrl("/parametrage/city");
  }
}
